import type { FC } from "react";
import React from "react";

import { Badge } from "../../../../Badge";

import type {
    BadgeProps,
    IconBadgeProps,
    IEmojiBadgeProps,
    IImageBadgeProps,
} from "../../../../Badge/Badge";

const TAG_BADGE_TEST_ID = "tag-badge-test-id";

type AbsentedProps = "size" | "stroke";

type TagBadgeProps =
    | Omit<IconBadgeProps, AbsentedProps>
    | Omit<IImageBadgeProps, AbsentedProps>
    | Omit<IEmojiBadgeProps, AbsentedProps>;

export const TagBadge: FC<TagBadgeProps> = (props) => {
    return <Badge {...(props as BadgeProps)} data-tsid={TAG_BADGE_TEST_ID} />;
};

TagBadge.displayName = "Tag.Badge";

export default TagBadge;
